import React, { useEffect, useState } from 'react';
import { useParams, useHistory, useNavigate } from 'react-router-dom';
import { db } from '../FireBase'; // Import Firestore
import { doc, getDoc,deleteDoc,updateDoc,collection,where,getDocs,query} from 'firebase/firestore';
import { Container, Col, Row, Card, Table,Button,Tab,Tabs,Form } from 'react-bootstrap';
import { faChartArea, faEdit, faFaceAngry, faFileExcel, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ToastAlert from '../components/ToastAlert';
import { Link } from 'react-router-dom';
import '../css/font.css';
import Loading from '../components/Loading';
import { generateExcelReport } from '../components/reportUtils';
import ManualPaymentModal from '../components/ManualPaymentModal';
import DiscontinueSchemeModal from '../components/DiscontinueSchemeModal';
import FileViewModal from '../components/FileViewModal';
import { getStorage, ref, deleteObject } from "firebase/storage";
import { FaTrash,FaPenClip, FaPen, FaPadlet, FaPenToSquare } from 'react-icons/fa6';
import ManualUnpaidModal from '../components/ManualUnpaidModal';





const SchemeDetail = () => {
    const { id } = useParams(); // Get the scheme ID from the URL
    const [scheme, setScheme] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');
    const navigate = useNavigate(); // Initialize useNavigate
    const [completedSchemes, setCompletedSchemes] = useState([]);
    const [activeSchemes, setActiveSchemes] = useState([]);
    const [customers, setCustomers] = useState([]); 
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [paidMonths, setPaidMonths] = useState([]);
    const [loadingCustomer, setLoadingCustomer] = useState({});
    const [loadingCustomer2, setLoadingCustomer2] = useState({});
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [activeTab, setActiveTab] = useState('Customers');
    const [activeTab2, setActiveTab2] = useState('All');
    const [showDiscontinueModal, setShowDiscontinueModal] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedSubscription, setSeletedSubscription] = useState(null);
    const [showFileModal,setFileModal] =useState(false);
    const [proofUrl,setProofUrl] = useState('');
    const [disNotes,setDisNotes] = useState('');
    const [unpaidCustomers, setUnpaidCustomers] = useState([]);
    const [lateFeeStatus, setLateFeeStatus] = useState({}); // Add this line
    const [searchCustomer, setSearchCustomer] = useState("");
    const [showUnpaidModal,setShowUnpaidModal]=useState(false);
    const [selectedSubscriptionId,setSelectedSubscriptionId]=useState("");
    const [selectedSchemeId,setSelectedSchemeId]=useState("");
    const [selectedUserId,setSelectedUserId]=useState("");
    const [tranasctionLoading,setTransactionLoading] = useState(false);
   
    

const handleDiscontinueSuccess = () => {
  fetchSchemeDetails(); // 🔄 re-fetch from Firestore
  fetchCustomers();
  fetchTransactionHistory();
};
    const fetchSchemeDetails = async () => {
        try {
            setLoading(true);
            const schemeRef = doc(db, 'schemes', id);
            const schemeDoc = await getDoc(schemeRef);
            if (schemeDoc.exists()) {
                setScheme({ id: schemeDoc.id, ...schemeDoc.data() });
            } else {
                console.log('No such document!');
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching scheme details:', error);
        }
    };
    const fetchCustomers = async () => {
        try {
            setLoading(true);
            const subscriptionsQuery = query(collection(db, 'subscriptions'), where('schemeId', '==', id));
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
            
            const subscriptionsData = subscriptionsSnapshot.docs.map(doc => doc.data());
            const customerPromises = subscriptionsData.map(async (subscription) => {
                const userRef = query(collection(db, 'users'), where('cusmid', '==', subscription.userId));
                const userSnapshot = await getDocs(userRef);
                if (!userSnapshot.empty) {
                    const userDoc = userSnapshot.docs[0];
                    return { id: userDoc.id, ...userDoc.data(),
                        totalMonths: subscription.totalMonths,
                        monthsPaid: subscription.paidMonths,
                        isActive: subscription.isActive ,
                        cusStatus: subscription.status,
                        disProof: subscription.discontinueData?.fileURL || '',
                        disNotes: subscription.discontinueData?.notes || '',
                        Paymentstatus:subscription.payments,
                        Quantity:subscription.quantity,
                        LateFee:subscription.LateFee,
                        subscriptionId: subscription.subscriptionId,

                     };
                } else {
                    console.log(`No such user document for userId: ${ subscription.userId}`);
                    return null;
                }
                
            });

            const customersData = await Promise.all(customerPromises);
            console.log(customersData);
            setCustomers(customersData.filter(customer => customer !== null));
            setLoading(false);
            
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchTransactionHistory = async () => {
        try {
          setTransactionLoading(true);
          const transactionsQuery = query(collection(db, 'transactions'), where('schemeId', '==', id));
          const transactionsSnapshot = await getDocs(transactionsQuery);
          const transactionsData = [];
      
          for (const docSnap of transactionsSnapshot.docs) {
            const transaction = { id: docSnap.id, ...docSnap.data() };
      
            // Fetch user details
            if (transaction.userId) {
              const userRef = query(collection(db, 'users'), where( 'cusmid','==',transaction.userId)); // or 'customers' if that's your collection name
              const userSnapshot = await getDocs(userRef);
      
              if (!userSnapshot.empty) {
                const userData = userSnapshot.docs[0].data(); // Assuming only one user matches
                transaction.customerName = userData.name || 'N/A';
                transaction.customerPhone = userData.phone || 'N/A';
              } else {
                transaction.customerName = 'Unknown';
                transaction.customerPhone = 'Unknown';
              }
            } 
            console.log(transactionsData)
            transactionsData.push(transaction);
          }
      
          setTransactions(transactionsData);
          console.log(transactionsData);
          setLoading(false);
        } catch (error) {
          console.error('Error fetching transaction history:', error);
          // setLoading(false);
        }finally{
          setTransactionLoading(false);
        }
      };
    
            useEffect(()=>{
                fetchCustomers();
                fetchSchemeDetails();
                fetchTransactionHistory();
               
            },[id]);

            useEffect(()=>{
                filterCustomersByPaymentStatus(customers);
            },[customers]);


            
           
      

     const handleCompleteAndClose = async (schemeId) => {
        try {
            setLoading(true);
          const schemeRef = doc(db, 'schemes', schemeId);
          await updateDoc(schemeRef, { status: "Completed" ,completedAt: new Date(),});
    
          // Update local state
          setActiveSchemes((prevSchemes) =>
              prevSchemes.filter((scheme) => scheme.id !== schemeId)
          );
    
          const completedScheme = activeSchemes.find((scheme) => scheme.id === schemeId);
          setCompletedSchemes((prevSchemes) => [
              ...prevSchemes,
              { ...completedScheme, status: "Completed" },
          ]);
    
          setToastMessage('Scheme marked as completed successfully.');
          setToastVariant('success');
          setShowToast(true);
        fetchSchemeDetails();
        setLoading(false);
          
      } catch (error) {
          console.error('Error marking scheme as complete:', error);
          setToastMessage('Error completing the scheme. Please try again.');
          setToastVariant('danger');
          setShowToast(true);
      }
    };

    const handleToggleStatus = async (schemeId, currentStatus) => {
        try {
            setLoading(true);
          const schemeRef = doc(db, 'schemes', schemeId);
      
          // Toggle the status value and update Firestore
          const newStatus = !currentStatus;
          await updateDoc(schemeRef, { status: newStatus });
      
          // Update local state to reflect the change
          setActiveSchemes((prevSchemes) =>
            prevSchemes.map((scheme) =>
              scheme.id === schemeId ? { ...scheme, status: newStatus } : scheme
            )
          );
      
          setCompletedSchemes((prevSchemes) =>
            prevSchemes.map((scheme) =>
              scheme.id === schemeId ? { ...scheme, status: newStatus } : scheme
            )
          );
      
          setToastMessage(`Scheme ${newStatus ? 'activated' : 'deactivated'} successfully.`);
          setToastVariant('success');
          setShowToast(true);
          fetchSchemeDetails();
            setLoading(false);
        } catch (error) {
          console.error('Error toggling scheme status:', error);
          setToastMessage('Error updating scheme status. Please try again.');
          setToastVariant('danger');
          setShowToast(true);
        }
      };
    
      const downloadReport = () => {
        const schemeSheet = {
            name: 'Scheme',
            data: [
                ['SCheme ID','Status', 'Name','Description', 'Created', 'Price','Duartion','Total value','Start date','Onboarding dates'],
                [
                    scheme.id, 
                    scheme.status,
                    scheme.name,
                    scheme.Description,
                    scheme.createdAt,
                    scheme.price,
                    scheme.schemeDuration,
                    scheme.totalSchemeValue,
                    scheme.SchemeStart, 
                    scheme.onboardingStart,
                    scheme.onboardingEnd,
                    
                ]
            ]
        };
        const customerSheet = {
            name: 'Customers',
            data: [
                ['Customer ID', 'Name', 'Email', 'Phone', 'Address','Dues','Quantity'],
                ...customers.map(customer => [
                    customer.cusmid,
                    customer.name,
                    customer.email,
                    customer.phone,
                    formatAddress(customer.address),
                    `${customer.monthsPaid}/${customer.totalMonths}`,
                    customer.Quantity,
                ])
            ]
        };
         const unPaidCustomers = {
            name: 'Unpaid Customers',
            data: [
                ['Customer ID', 'Name', 'Email', 'Phone', 'Address','Dues','Quantity'],
                ...unpaidCustomers.map(customer => [
                    customer.cusmid,
                    customer.name,
                    customer.email,
                    customer.phone,
                    formatAddress(customer.address),
                    `${customer.monthsPaid}/${customer.totalMonths}`,
                    customer.Quantity,
                ])
            ]
        };

        const transactionSheet = {
            name: 'Transactions',
            data: [
                ['Transaction ID','Customer id','Customer name','Customer phone' ,'Amount','Type', 'Date'],
                ...transactions.map(transaction => [
                    transaction.transactionId,
                    transaction.userId,
                    transaction.customerName,
                    transaction.customerPhone,
                    transaction.paymentAmount,
                    transaction.paymentType,
                    new Date(transaction.paymentDate.seconds * 1000).toLocaleString()
                ])
            ]
        };

        const productSheet = {
            name: 'Products',
            data: [
                ['Product ID', 'Name', 'Quantity','Mesurement','Mesurement type'],
                ...scheme.productDetails.map(product => [
                    product.productId,
                    product.productName,
                    product.quantity,
                    product.unitValue,
                    product.unitType    

                ])
            ]
        };


        generateExcelReport([schemeSheet, customerSheet,unPaidCustomers, transactionSheet,productSheet], `${scheme.name}_Detailed_Report.xlsx`);
    };

    const formatAddress = (address) => {
        if (typeof address === 'object') {
            return `${address.address}, ${address.city}, ${address.state}, ${address.postalCode}, ${address.country}`;
        }
        return address;
    }

  const handleToggleCustomerStatus = async (cusmid, currentStatus, subscriptionId) => {
  try {
    console.log(cusmid, currentStatus, subscriptionId);
    setLoadingCustomer((prev) => ({ ...prev, [subscriptionId]: true }));

    const subscriptionsQuery = query(
      collection(db, "subscriptions"),
      where("userId", "==", cusmid),
      where("schemeId", "==", id),
      where("subscriptionId", "==", subscriptionId)
    );

    const subscriptionsSnapshot = await getDocs(subscriptionsQuery);

    if (!subscriptionsSnapshot.empty) {
      const subscriptionDoc = subscriptionsSnapshot.docs[0];
      console.log(subscriptionDoc.id);
      const customerRef = doc(db, "subscriptions", subscriptionDoc.id);
      const newStatus = !currentStatus;
        console.log(newStatus);
     await updateDoc(customerRef, { isActive: newStatus,isActiveBy:"Admin"});

      // ✅ Update only that subscription row
      setCustomers((prevCustomers) =>
        prevCustomers.map((customer) =>
          customer.subscriptionId === subscriptionId
            ? { ...customer, isActive: newStatus }
            : customer
        )
      );

      setToastMessage(`Customer ${newStatus} successfully.`);
      setToastVariant("success");
      setShowToast(true);
    } else {
      setToastMessage("Error updating status. No subscription found.");
      setToastVariant("danger");
      setShowToast(true);
    }
  } catch (error) {
    console.error("Error toggling customer status:", error);
    setToastMessage("Error updating status. Please try again.");
    setToastVariant("danger");
    setShowToast(true);
  } finally {
    setLoadingCustomer((prev) => ({ ...prev, [subscriptionId]: false }));
    // fetchCustomers();
  }
};


const handleDiscontinue = (userId, schemeId, subscriptionId, discontinueData) => {
    console.log(userId, schemeId, subscriptionId, discontinueData);

    setCustomers((prevCustomers) =>
        prevCustomers.map((customer) =>
            customer.userId === userId &&
            customer.schemeId === schemeId &&
            customer.subscriptionId === subscriptionId
                ? {
                      ...customer,
                      cusStatus: discontinueData.status,
                      isActive: discontinueData.isActive,
                      disProof: discontinueData.fileURL,
                  }
                : customer
        )
    );
};


    const filterCustomersByPaymentStatus = (customers) => {
        console.log("filter", customers);
    
        const currentMonthYear = new Date().toISOString().slice(0, 7); // Get current month and year in "YYYY-MM" format
        const paid = [];
        const unpaid = [];
        console.log(currentMonthYear);
    
        customers.forEach((customer) => {
            if (customer.cusStatus !== "discontinued") {
                const paymentForCurrentMonth = customer.Paymentstatus.find(payment => payment.month === currentMonthYear);
                if (paymentForCurrentMonth) {
                   if (paymentForCurrentMonth.paymentStatus === 'Pending') {
                        unpaid.push(customer);
                    }
                }
            }
        });
    
        console.log("fetch unpaid",unpaid)
        setUnpaidCustomers(unpaid);
    };

  const handleToggleCustomerLateFee = async (cusmid, currentStatus, subscriptionId) => {
  try {
    setLoadingCustomer2((prev) => ({ ...prev, [subscriptionId]: true }));

    const subscriptionsQuery = query(
      collection(db, "subscriptions"),
      where("userId", "==", cusmid),
      where("schemeId", "==", id),
      where("subscriptionId", "==", subscriptionId)
    );

    const subscriptionsSnapshot = await getDocs(subscriptionsQuery);

    if (!subscriptionsSnapshot.empty) {
      const subscriptionDoc = subscriptionsSnapshot.docs[0];
      const customerRef = doc(db, "subscriptions", subscriptionDoc.id);
      const newStatus = !currentStatus;

      await updateDoc(customerRef, { LateFee: newStatus });

      // ✅ Update only that subscription row
      setCustomers((prevCustomers) =>
        prevCustomers.map((customer) =>
          customer.subscriptionId === subscriptionId
            ? { ...customer, LateFee: newStatus }
            : customer
        )
      );

      setToastMessage(`Late Fee ${newStatus ? "enabled" : "disabled"} successfully.`);
      setToastVariant("success");
      setShowToast(true);
    } else {
      setToastMessage("Error updating Late Fee. No subscription found.");
      setToastVariant("danger");
      setShowToast(true);
    }
  } catch (error) {
    console.error("Error toggling late fee:", error);
    setToastMessage("Error updating Late Fee. Please try again.");
    setToastVariant("danger");
    setShowToast(true);
  } finally {
    setLoadingCustomer2((prev) => ({ ...prev, [subscriptionId]: false }));
  }
};


    if (!scheme || loading) {
    
            // Render loading screen
            return (
              <div className="loading-screen">
              <Loading/>
              </div>
            );
          
    }

    const handleDeleteCustomerSubscription = async (subscriptionId, userId) => {
  if (!window.confirm("Are you sure you want to delete this subscription and all related data?")) return;

  try {
    setLoading(true);

    // 1️⃣ Delete subscription document
    const subscriptionsQuery = query(
      collection(db, "subscriptions"),
      where("subscriptionId", "==", subscriptionId),
      where("userId", "==", userId)
    );
    const subscriptionsSnapshot = await getDocs(subscriptionsQuery);

    if (!subscriptionsSnapshot.empty) {
      const subscriptionDoc = subscriptionsSnapshot.docs[0];
      await deleteDoc(doc(db, "subscriptions", subscriptionDoc.id));
    }

    // 2️⃣ Find and delete all transactions related to this subscription
    const transactionsQuery = query(
      collection(db, "transactions"),
      where("subscriptionId", "==", subscriptionId)
    );
    const transactionsSnapshot = await getDocs(transactionsQuery);
    const storage = getStorage();

    for (const txnDoc of transactionsSnapshot.docs) {
      const txnData = txnDoc.data();

      // Delete image from storage if exists
      if (txnData.receiptURL) {
        const fileRef = ref(storage, txnData.receiptURL); // Ensure this is the correct path
        try {
          await deleteObject(fileRef);
        } catch (error) {
          console.warn("Failed to delete image from storage:", error);
        }
      }

      // Delete transaction doc
      await deleteDoc(doc(db, "transactions", txnDoc.id));
    }

    // 3️⃣ Update local state
    setCustomers((prevCustomers) =>
      prevCustomers.filter((customer) => customer.subscriptionId !== subscriptionId)
    );

    setToastMessage("Subscription and related transactions deleted successfully.");
    setToastVariant("success");
    setShowToast(true);
    setLoading(false);
  } catch (error) {
    console.error("Error deleting subscription:", error);
    setToastMessage("Error deleting subscription. Please try again.");
    setToastVariant("danger");
    setShowToast(true);
    setLoading(false);
  }
};



    return (
        <Container fluid className="mt-5">
             <ToastAlert
                show={showToast}
                setShow={setShowToast}
                message={toastMessage}
                variant={toastVariant}
            />
          <div className="d-flex justify-content-between align-items-center">
            <h1>{scheme.name}</h1>
          
            <div>
                
            {/* <Button variant="primary" className="btn me-2" onClick={() => setShowPaymentModal(true)}>
                Manual Entry
            </Button> */}
                 <Button
                    variant={scheme.status ? 'success' : 'outline-secondary'}
                    className="btn  m-1"
                    disabled={scheme.status === 'Completed'} // Disable if already completed
                    onClick={() => handleToggleStatus(scheme.id, scheme.status)}
                >
                    {scheme.status ? 'Active' : 'Inactive'}
                </Button>
                {/* <Button variant="danger" className='btn  m-1' disabled={scheme.status} onClick={() => handleDeleteScheme(scheme.id)} >
                    <FontAwesomeIcon icon={faTrash} className="fa-icon" />Delete
                </Button> */}
                <Button   as={Link}
                          to={`/statisticesdetailed/${scheme.id}`} variant="outline-danger" className='btn m-1'  style={{ marginLeft: '5px' }} >
                    <FontAwesomeIcon icon={faChartArea} className="fa-icon" />Statistices
                </Button>
                <Button
                    variant="outline-success"
                    className="btn  m-1"
                    onClick={() => handleCompleteAndClose(scheme.id)}
                    disabled={scheme.status === 'Completed'} // Disable if already completed
                    
                >  Complete and Close
                   
                </Button>
                <Button variant="outline-success" className='btn m-1' onClick={downloadReport}>
                    <FontAwesomeIcon icon={faFileExcel} className="fa-icon" /> Download Report
                </Button>
            </div>
        </div>
        <h3>{scheme.id}</h3>
        <p><strong>Onboarding Dates:</strong> {scheme.onboardingStart} to {scheme.onboardingEnd}</p>
        <p><strong>Created Dates:</strong> {scheme.createdAt ? new Date(scheme.createdAt.seconds * 1000).toLocaleString() : 'Not Available'}</p>
          
            <Row>
                <Col md={4} sm={12} className="mb-4">
                    <Card className="h-100">
                        <Card.Body className="d-flex justify-content-center align-items-center">
                            <img src={scheme.image} alt={scheme.name} className="img-fluid" />
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4} sm={12} className="mb-4">
                    <Card className="h-100">
                        <Card.Body>
                            <h6>Products</h6>
                            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                            <Table striped bordered hover responsive >
                                <thead>
                                    <tr className='scheme-det-font-head'>
                                        <th>Product</th>
                                        <th>Mesurement</th>
                                        <th>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {scheme.productDetails.map((product, index) => (
                                        <tr key={index} className='scheme-det-font'>
                                            <td>{product.productName}</td>
                                            <td>{product.unitValue}{product.unitType}</td>
                                            <td>{product.quantity}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4} sm={12}>
                    <Row>
                        <Col md={6} sm={6} className="mb-4">
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{scheme.price}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <center>
                                        <h5 className="cus-head">Price per month</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} sm={6} className="mb-4">
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{scheme.schemeDuration}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <center>
                                            <h5 className="cus-head">Duration months</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} sm={6} className="mb-4">
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{scheme.totalSchemeValue}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                    <center>
                                        <h5 className="cus-head">Total value</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} sm={6} className="mb-4">
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{customers.length}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                    <center>
                                        <h5 className="cus-head">Total user</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Tabs
                id="scheme-details"
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="mb-3"
            >
                <Tab eventKey="Customers" title="Customers">

                    <Card className="mb-4">
                    <Card.Body>
                        <h3>Customers</h3>
                        <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                        <Tabs
                            id="user-payments"
                            activeKey={activeTab2}
                            onSelect={(l) => setActiveTab2(l)}
                            className="mb-3"
                        >
                            <Tab eventKey="All" title="All">
                            <Form className="mb-3">
                                <Form.Control
                                type="text"
                                placeholder="Search by name, phone, or customer ID"
                                value={searchCustomer}
                                onChange={(e) => setSearchCustomer(e.target.value)}
                                />
                            </Form>
                                <Table striped bordered hover responsive>
                             
                                <thead>
                                    <tr className='scheme-det-font-head'>
                                    <th>Cus ID</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Dues</th>
                                    <th>Quantity</th>
                                    <th>Status</th>
                                    <th>Late Fee</th>
                                    <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
      {customers
        .filter((customer) =>
          customer.name?.toLowerCase().includes(searchCustomer.toLowerCase()) ||
          customer.phone?.includes(searchCustomer) ||
          customer.cusmid?.toLowerCase().includes(searchCustomer.toLowerCase())
        )
        .map((customer, index) => (
          <tr key={index} className='scheme-det-font'>
            <td>
              <Link
                to={`/customerdetails/${customer.cusmid}`}
                style={{ textDecoration: 'none', color: 'blue' }}
              >
                {customer.cusmid}
              </Link>
            </td>
            <td>{customer.name}</td>
            <td>{customer.phone}</td>
            <td>{customer.monthsPaid}/{customer.totalMonths}</td>
            <td>{customer.Quantity}</td>
            <td>
              {customer.cusStatus !== 'discontinued' ? (
                <Button
                  className='btn-sm'
                  variant={customer.isActive ? 'outline-success' : 'outline-danger'}
                  onClick={() => handleToggleCustomerStatus(customer.cusmid, customer.isActive,customer.subscriptionId)}
                  disabled={loadingCustomer[customer.subscriptionId]}
                >
                  {loadingCustomer[customer.subscriptionId] ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    customer.isActive ? 'Active' : 'Blocked'
                  )}
                </Button>
              ) : (
                <p>{customer.cusStatus}</p>
              )}
            </td>
            <td>
           <Button
  className="btn-sm"
  variant={customer.LateFee ? "outline-success" : "outline-danger"}
  onClick={() =>
    handleToggleCustomerLateFee(customer.cusmid, customer.LateFee, customer.subscriptionId)
  }
  disabled={loadingCustomer2[customer.subscriptionId]}
>
  {loadingCustomer2[customer.subscriptionId]
    ? "Updating..."
    : customer.LateFee
    ? "Enabled"
    : "Disabled"}
</Button>

            </td>
            <td>
              <>
                {customer.cusStatus === "discontinued" && !customer.isActive ? (
                  <Button
                    variant="outline-info"
                    className="btn-sm me-2"
                    onClick={() => {
                      setProofUrl(customer.disProof);
                      setDisNotes(customer.disNotes);
                      setFileModal(true);
                    }}
                  >
                    Show Proof
                  </Button>
                ) : (
                    <>
                        <Button
                            variant="outline-warning"
                            className="btn-sm me-2"
                            onClick={() => {
                            setSelectedCustomer(customer.cusmid);
                            setSeletedSubscription(customer.subscriptionId);
                            setShowDiscontinueModal(true);
                            }}
                        >
                            Discontinue Scheme
                        </Button>

                        <Button
                        variant="outline-danger"
                        className="btn-sm"
                        onClick={() => handleDeleteCustomerSubscription(customer.subscriptionId, customer.cusmid)}
                        style={{margin:'5px'}}
                        >
                        <FaTrash /> 
                        </Button>
                      <Button
                          variant="outline-warning"
                          className="btn-sm"
                          onClick={() => {
                            setSelectedSubscriptionId(customer.subscriptionId);
                            setSelectedSchemeId(id);
                            setSelectedUserId(customer.cusmid);
                            setShowUnpaidModal(true);
                          }}
                        >
                          <FaPenToSquare /> 
                        </Button>

                    </>
                )}
              </>
            </td>
          </tr>
        ))}
    </tbody>
                            </Table>
                            </Tab>
                          
                   
                                
<Tab eventKey="Unpaid customers(This month)" title="Unpaid customers(This month)">
    <Table striped bordered hover responsive>
        <thead>
            <tr className='scheme-det-font-head'>
                <th>Cus ID</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Dues</th>
                <th>Quantity</th>
                <th>Status</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            {unpaidCustomers.map((customer, index) => (
                <tr key={index} className='scheme-det-font'>
                    <td><Link to={`/customerdetails/${customer.cusmid}`} style={{ textDecoration: 'none', color: 'blue' }}>{customer.cusmid}</Link></td>
                    <td>{customer.name}</td>
                    <td>{customer.phone}</td>
                    <td>{customer.monthsPaid}/{customer.totalMonths}</td>
                    <td>{customer.Quantity}</td>
                    <td>
                        {customer.cusStatus !=='discontinued' ?(
                      <Button
                            className="btn"
                            variant={customer.isActive ? "outline-success" : "outline-danger"}
                            onClick={() =>
                                handleToggleCustomerStatus(customer.cusmid, customer.isActive, customer.subscriptionId)
                            }
                            disabled={loadingCustomer2[customer.subscriptionId]}
                            >
                            {
                              loadingCustomer2[customer.subscriptionId]
                                ? "Updating..."
                                : (customer.isActive ? "Active" : "Blocked")
                            }

                            </Button>

                        ):(
                            <p>{customer.cusStatus}</p>
                        )
                        }              
                    </td>
                    <td>
                        <>
                            {customer.cusStatus === "discontinued" && !customer.isActive ? (
                                <Button variant="outline-info" className="btn me-2" onClick={() => {
                                    setProofUrl(customer.disProof);
                                    setDisNotes(customer.disNotes);
                                    setFileModal(true);
                                }}>
                                    Show Proof
                                </Button>
                            ) : (
                                <Button variant="outline-warning" className="btn me-2" onClick={() => {
                                    setSelectedCustomer(customer.cusmid);
                                    setSeletedSubscription(customer.subscriptionId);
                                    setShowDiscontinueModal(true);
                                }}>
                                    Discontinue Scheme
                                </Button>
                            )}
                           
                        </>
                    </td>
                </tr>
            ))}
        </tbody>
    </Table>
</Tab>
                            
                        </Tabs>
                       
                        </div>
                    </Card.Body>
                </Card>


                </Tab>
               <Tab eventKey="Transactions" title="Transactions">
                  {tranasctionLoading ? (
                    <div className="loading-screen">
                      <Loading />
                    </div>
                  ) : (
                    <Card className="mb-4">
                      <Card.Body>
                        <h3>Transactions</h3>

                        <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                          <Table striped bordered hover responsive>
                            <thead>
                              <tr className='scheme-det-font-head'>
                                <th>Date</th>
                                <th>Id</th>
                                <th>Customer Id</th>
                                <th>Customer Name</th>
                                <th>Customer Phone</th>
                                <th>Amount</th>
                                <th>Type</th>
                              </tr>
                            </thead>

                            <tbody>
                              {transactions.map((transaction, index) => (
                                <tr key={index} className='scheme-det-font'>
                                  <td>
                                    {transaction.paymentDate?.seconds
                                      ? new Date(transaction.paymentDate.seconds * 1000).toLocaleDateString()
                                      : "N/A"}
                                  </td>

                                  <td>{transaction.transactionId}</td>

                                  <td>
                                    <Link
                                      to={`/customerdetails/${transaction.userId}`}
                                      style={{ textDecoration: "none", color: "blue" }}
                                    >
                                      {transaction.userId}
                                    </Link>
                                  </td>

                                  <td>{transaction.customerName}</td>
                                  <td>{transaction.customerPhone}</td>
                                  <td>{transaction.paymentAmount}</td>
                                  <td>{transaction.paymentType}</td>
                                </tr>
                              ))}
                            </tbody>

                          </Table>
                        </div>
                      </Card.Body>
                    </Card>
                  )}
                </Tab>

                </Tabs>
            <ManualPaymentModal
                show={showPaymentModal}
                onHide={() => setShowPaymentModal(false)}
                schemeId={id}
                customers={customers}
            />
            <DiscontinueSchemeModal
                show={showDiscontinueModal}
                onHide={() => setShowDiscontinueModal(false)}
                schemeId={id}
                customerId={selectedCustomer}
                subscriptionId={selectedSubscription}
                onDiscontinue={handleDiscontinue}
                onSuccess={handleDiscontinueSuccess} // ✅

            />
            <FileViewModal
            show={showFileModal}
            onHide={()=> setFileModal(false)}
            fileUrl={proofUrl}
            notes={disNotes}
            />
            <ManualUnpaidModal
              show={showUnpaidModal}
              onHide={() => setShowUnpaidModal(false)}
              subscriptionId={selectedSubscriptionId}
              schemeId={selectedSchemeId}
              userId={selectedUserId}
            />


        </Container>
        
    );
};

export default SchemeDetail;